import React from 'react';

type Variant = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'critical' | 'high' | 'medium' | 'low';

const styles: Record<Variant, string> = {
  default:  'bg-gray-100 text-gray-700',
  success:  'bg-green-100 text-green-800',
  warning:  'bg-yellow-100 text-yellow-800',
  danger:   'bg-red-100 text-red-800',
  info:     'bg-blue-100 text-blue-800',
  critical: 'bg-red-100 text-red-800 font-semibold',
  high:     'bg-orange-100 text-orange-800',
  medium:   'bg-yellow-100 text-yellow-800',
  low:      'bg-gray-100 text-gray-600',
};

export function Badge({ children, variant = 'default', className = '' }: { children: React.ReactNode; variant?: Variant; className?: string }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs ${styles[variant]} ${className}`}>
      {children}
    </span>
  );
}

export function SeverityBadge({ severity }: { severity: string }) {
  const v = severity.toLowerCase() as Variant;
  return <Badge variant={v}>{severity}</Badge>;
}

export function StatusBadge({ status }: { status: string }) {
  const map: Record<string, Variant> = {
    NEW: 'info', ACKNOWLEDGED: 'warning', RESOLVED: 'success', DISMISSED: 'default',
    COMPLETED: 'success', FAILED: 'danger', PROCESSING: 'info', PARTIALLY_COMPLETED: 'warning',
    active: 'success', inactive: 'default',
  };
  return <Badge variant={map[status] ?? 'default'}>{status.replace('_', ' ')}</Badge>;
}

